module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "40",
      "height": "40",
      "viewBox": "0 0 40 40",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": "black"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.5858 11.5858C11.2107 11.9609 11 12.4696 11 13V14C11 22.284 17.716 29 26 29H27C27.5304 29 28.0391 28.7893 28.4142 28.4142C28.7893 28.0391 29 27.5304 29 27V23.721C29.0001 23.511 28.934 23.3064 28.8112 23.136C28.6885 22.9657 28.5152 22.8383 28.316 22.772L23.823 21.274C23.5947 21.1981 23.3466 21.2071 23.1244 21.2993C22.9021 21.3915 22.7205 21.5607 22.613 21.776L21.483 24.033C19.0345 22.9267 17.0733 20.9655 15.967 18.517L18.224 17.387C18.4393 17.2795 18.6085 17.0979 18.7007 16.8756C18.7929 16.6534 18.8019 16.4053 18.726 16.177L17.228 11.684C17.1617 11.485 17.0345 11.3118 16.8644 11.189C16.6942 11.0663 16.4898 11.0002 16.28 11H13C12.4696 11 11.9609 11.2107 11.5858 11.5858Z",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f68485a","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/phone.vue
// module id = 737ba45628b01ab792b8
// module chunks = 89